import { CenterOfGravity, GridPosition } from '../types/morningstar.types';

/**
 * Extracts row and column positions from center of gravity string
 * @param centerOfGravity - Center of gravity position string
 * @returns GridPosition object containing row and column positions
 */
export const getGridPosition = (
  centerOfGravity: CenterOfGravity,
): GridPosition => {
  if (!centerOfGravity) {
    return { row: null, col: null };
  }
  const [row, col] = centerOfGravity.split('-');
  return { row, col } as const;
};
